module.exports = __webpack_public_path__ + "static/assets/27d2c18b649facf4d508421936644229.png";